import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      role="navigation"
      aria-label="Hauptnavigation"
      className={`fixed w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-slate-950/80 backdrop-blur-md border-b border-slate-800 py-3' : 'bg-transparent py-5'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-3 group" aria-label="ErgoFocus Startseite">
            <img 
              src="/ErgoFocus-Icon.png" 
              alt="" 
              className="w-8 h-8 object-contain transition-transform group-hover:scale-110"
              aria-hidden="true"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <div className="flex flex-col leading-none">
              <span className="text-xl font-bold text-white tracking-tight">
                Ergo<span className="text-orange-500">Focus</span>
              </span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-semibold mt-0.5">
                Pomodoro Timer
              </span>
            </div>
          </Link>

          {/* Navigation links removed as requested */}
          <div className="hidden md:block">
            {/* Empty space or secondary CTA could go here if needed in future */}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;